export const MEDICINAL_PRODUCT_LIST = '/api/MedicinalProduct';
export const getMedicationPackList = (medicinalProductId: number) =>
    `/api/MedicinalProduct/${medicinalProductId}/MedicationPack`;
export const ISSUE_PRESCRIPTION = '/api/Prescription';
export const getPrescriptionsEndpoint = (appointmentId: number) =>
    `/api/Prescription/${appointmentId}`;
export const getPrescriptionPdfEndpoint = (prescriptionSetId: string) =>
    `/api/PrescriptionSet/${prescriptionSetId}/pdf`;
export const PRESCRIPTION_HISTORY = '/api/Prescription/History';
export const getDraftPrescriptionSetExistsEndpoint = (appointmentId: number) => `/api/Prescription/Draft/Exists/${appointmentId}`;
export const CREATE_PRESCRIPTION_DRAFT = '/api/Prescription/Draft';
export const getPrescriptionDraftEndpoint = (appointmentId: number) => `/api/Prescription/Draft/${appointmentId}`;
export const EWUS_VERIFICATION = '/api/Ewus';